import { render, staticRenderFns } from "./AwarenessBar.vue?vue&type=template&id=f59a11f0&scoped=true"
import script from "./AwarenessBar.vue?vue&type=script&lang=js"
export * from "./AwarenessBar.vue?vue&type=script&lang=js"
import style0 from "./AwarenessBar.vue?vue&type=style&index=0&id=f59a11f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a11f0",
  null
  
)

export default component.exports